//account
import platLogin from '@/pages/account/login'
import platRegister from '@/pages/account/register'
//dashboard
import platDashboard from '@/pages/dashboard'
//error
import platError403 from '@/pages/error/403'
import platError404 from '@/pages/error/404'
import platError500 from '@/pages/error/500'
//platform
import platCode from '@/pages/platform/code'
import platDict from '@/pages/platform/dict'
import platFile from '@/pages/platform/file'
import platPlatform from '@/pages/platform/platform'
import platProduct from '@/pages/platform/product'
//system
import platDept from '@/pages/system/dept'
import platGroup from '@/pages/system/group'
import platLog from '@/pages/system/log'
import platMenu from '@/pages/system/menu'
import platOrg from '@/pages/system/org'
import platPost from '@/pages/system/post'
import platRole from '@/pages/system/role'
import platUser from '@/pages/system/user'

// 增加iconfont彩色图标
import '@/styles/font/iconfont.js';
import '@/styles/index.less';

const components = {
    platLogin,
    platRegister,
    platDashboard,
    platError403,
    platError404,
    platError500,
    platCode,
    platDict,
    platFile,
    platPlatform,
    platProduct,
    platDept,
    platGroup,
    platLog,
    platMenu,
    platOrg,
    platPost,
    platRole,
    platUser
}
const install = Vue => {
    Object.keys(components).forEach((key) => {
        Vue.component(key, components[key]);
    });
};

// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default install;


// WEBPACK FOOTER //
// ./src/pages/index.js